import {
    Container,
    Heading,
    Stack,
    Text,
    Button,
  } from '@chakra-ui/react';
  import { motion } from "framer-motion";


  export default function Home() {
    return (
      <Container maxW={'9xl'}>
        
        <Stack
          textAlign={'center'}
          align={'center'}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 20, md: 28 }}>
            <motion.div
    className="container"
    initial={{ scale: 0 }}
    animate={{ rotate: 0, scale: 1.6 }}
    whileHover={{ scale: 1.9 }}
    whileTap={{ scale: 1.9 }}
    transition={{
      type: "spring",
      stiffness: 300,
      damping: 20
    }}>
            <Heading
            fontWeight={900}
            fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}>
            Gracy {' '}
            <Text as={'span'} color={'blue.400'}>
              Patel
            </Text>.
          </Heading>
    </motion.div>
    <br/>
    
          <Text color={'gray.600'} maxW={'5xl'} fontSize={{ base: '2xl', sm: '2xl', md: '2xl' }}>
            Love | Budding Computer Science Engineer | Designer & Developer | Minimal & Creative
          </Text>

        </Stack>
      </Container>
    );
  }
